/**
 * @param {*} state
 * @param {*} payload
 */
export const retrieveClients = (state, payload) => {
  let { data } = payload

  state.clients = data
}
